import { createSelector } from 'reselect';
import { RootState } from '@reducers';
import { PermissionTemplatesState } from '@reducers/permission-templates';
import { PermissionsState } from '@reducers/permissions';

// List
export const getPermissions = (state: RootState): PermissionsState => state.permissions;
export const getPermissionsList = createSelector(getPermissions, (permission) => permission?.data);
export const getIsPermissionsLoading = createSelector(getPermissions, (permission) => permission?.loading);

// Templates List
export const getPermissionTemplates = (state: RootState): PermissionTemplatesState => state.permissionTemplates;
export const getPermissionTemplatesList = createSelector(getPermissionTemplates, (templates) => templates?.data);
